import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: 0,
  isVisible: false,
  background: '#000000',
  timeout: 1000,
  icon:'close-outline',
  position: 'toast-center',
  toastMessage: ''
}

export const appToastSlice = createSlice({
  name: 'appToast',
  initialState,
  reducers: {
    showAppToast: (state, action) => {
      const {
        toastMessage,
        background,
        icon,
        position,
        timeout,
        isVisible
      } = action.payload
      state.isVisible = isVisible
      state.toastMessage = toastMessage
      state.background = background
      state.icon = icon
      state.position = position
      state.timeout = timeout
    },
    hideAppToast: (state, action) => {
      state.isVisible = false
      state.toastMessage = ''
    }
  }
})

export const { showAppToast, hideAppToast } = appToastSlice.actions;


export default appToastSlice.reducer
